var __jsx = React.createElement;
import React from "react";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
var InstallmentSectionSkeleton = function InstallmentSectionSkeleton(_ref) {
  var _ref$numberOfCards = _ref.numberOfCards,
    numberOfCards = _ref$numberOfCards === void 0 ? 4 : _ref$numberOfCards;
  return /*#__PURE__*/React.createElement("ul", {
    className: "flex gap-5 flex-nowrap overflow-auto px-4 snap-x snap-mandatory lg:grid lg:grid-cols-[repeat(auto-fill,minmax(273px,1fr))] lg:gap-5 list-none lg:pb-0 lg:px-0"
  }, Array.from({
    length: numberOfCards
  }, function (_, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: "skeleton-".concat(index),
      className: "flex-none snap-center min-h-full lg:w-full w-[300px]"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rounded-lg overflow-hidden bg-white shadow-sm"
    }, /*#__PURE__*/React.createElement(BoxLoading, {
      divHeight: 200,
      divWidth: "100%",
      appearance: {
        color: "gray",
        opacity: "light"
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "p-4 space-y-3"
    }, /*#__PURE__*/React.createElement(BoxLoading, {
      divHeight: 20,
      divWidth: "100%",
      appearance: {
        color: "gray",
        opacity: "light"
      }
    }), /*#__PURE__*/React.createElement(BoxLoading, {
      divHeight: 24,
      divWidth: 180,
      appearance: {
        color: "gray",
        opacity: "light"
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex gap-2"
    }, /*#__PURE__*/React.createElement(BoxLoading, {
      divHeight: 16,
      divWidth: 80,
      appearance: {
        color: "gray",
        opacity: "light"
      }
    }), /*#__PURE__*/React.createElement(BoxLoading, {
      divHeight: 16,
      divWidth: 80,
      appearance: {
        color: "gray",
        opacity: "light"
      }
    })), /*#__PURE__*/React.createElement(BoxLoading, {
      divHeight: 36,
      divWidth: "100%",
      className: "rounded",
      appearance: {
        color: "gray",
        opacity: "light"
      }
    }))));
  }));
};
export default InstallmentSectionSkeleton;